import './App.css';
import './styles/flow-pages.css';
import './styles/workspace-typography.css';
import './styles/workspace-layout.css';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BottomNavigation from './components/appbar/BottomNavigation';
import DesktopNavigation from './components/appbar/DesktopNavigation';
import { useSimulador } from './components/Context_simulador/simulador_context';
import { NumericValidationProvider } from './components/numeric_validation/NumericValidation';

const routesWithoutWorkspaceNavigation = [
  '/',
  '/termos',
  '/inicial',
  '/Boas_vindas',
  '/potencialize',
  '/tec_pec',
];

const routesWithOriginalBackground = ['/', '/termos', '/Boas_vindas', '/tec_pec', '/inicial'];

function App() {
  const location = useLocation();
  const { systemMode } = useSimulador();
  const isTermsRoute = location.pathname === '/termos';

  const showWorkspaceNavigation = !routesWithoutWorkspaceNavigation.includes(location.pathname);
  const surfaceVariant = isTermsRoute
    ? 'app-shell__surface--reading'
    : showWorkspaceNavigation
      ? 'app-shell__surface--workspace'
      : 'app-shell__surface--onboarding';

  useEffect(() => {
    const isBeforePotentialize =
      routesWithOriginalBackground.includes(location.pathname) && !location.state?.afterPotentialize;
    const shouldUseCriaBackground = systemMode === 'cria' && !isBeforePotentialize;

    document.body.classList.toggle('theme-cria', shouldUseCriaBackground);
  }, [location.pathname, location.state, systemMode]);

  useEffect(() => {
    return () => {
      document.body.classList.remove('theme-cria');
    };
  }, []);

  return (
    <div className={`app-shell background-image font-poppins${showWorkspaceNavigation ? ' app-shell--workspace' : ''}`}>
      {showWorkspaceNavigation && <DesktopNavigation />}

      <main
        id="main-content"
        className={`app-shell__main${showWorkspaceNavigation ? ' app-shell__main--workspace' : ''}`}
      >
        <div className={`app-shell__surface ${surfaceVariant}`}>
          <div key={location.pathname} className="motion-page w-full flex flex-col items-center">
            <NumericValidationProvider>
              <Outlet />
            </NumericValidationProvider>
          </div>
        </div>
      </main>

      {showWorkspaceNavigation && <BottomNavigation />}
    </div>
  );
}

export default App;
